import AoneService from "../axiosbase";
//get Pickup revenue
export const getPickupRevenue = async (data) => {
    try  {
        return await AoneService.post(`revenue/api/v1/revenue/pickup`,data)
    } catch (error) {
        return error;
    }
}
//get pickup revenue by tracking id
export const getPickupRevenuebyId = async (params) => {
   try  {
       return await AoneService.get(`revenue/api/v1/revenue/pickup/${params}`)
   } catch (error) {
       return error;
   }
}
//export pickup revenue
export const exportPickupRevenue = async (params) => {
   try {
      return await AoneService.get(`revenue/api/v1/revenue/pickup/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  };
//get delivery revenue
export const getDeliveryRevenue = async (data) => {
   try  {
      return await AoneService.post(`revenue/api/v1/revenue/delivered`,data)
  } catch (error) {
      return error;
  }
  };
//get pickup revenue by tracking id
export const getDeliveryRevenuebyId = async (params) => {
   try  {
       return await AoneService.get(`revenue/api/v1/revenue/delivered/${params}`)
   } catch (error) {
       return error;
   }
}
//export delivery revenue
export const exportDeliveryRevenue = async (params) => {
   try {
      return await AoneService.get(`revenue/api/v1/revenue/delivered/export${params}`, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
}

//INVOICE AUTOMATION-Failed Invoices
//filter delivery revenue discrepancy
export const getFailedInvoices = async (data) => {
  try {
    return await AoneService.post(`revenue/api/v1/invoice/`,data);
  } catch (error) {
    return error;
  }
};
//failed invoice in revenue
export const getFailedRevenue = async (data) => {
  try {
    return await AoneService.post(`revenue/api/v1/revenue/invalid-records`,data);
  } catch (error) {
    return error;
  }
};
//push invoice
export const pushInvoices = async (data) => {
   try {
    return await AoneService.post(`revenue/api/v1/invoice/push/failed/trackings`,data);
  } catch (error) {
    return error;
  }
};
//get failed invoice by tracking id
export const rePushInvoice = async (data) => {  
  try {
    return await AoneService.post(`revenue/api/v1/invoice/repush/invoice`,data);
  } catch (error) {
    return error;
  }
};
//push all for invoices
export const pushAllInvoices = async (data) => {
   try {
    return await AoneService.post(`revenue/api/v1/invoice/push/failed/filter`,data);
  } catch (error) {
    return error;
  }
};
//push all for staging
export const pushAllStageInvoices = async (data) => {
   try {
    return await AoneService.post(`revenue/api/v1/invoice/push/stage/filter`,data);
  } catch (error) {
    return error;
  }
};
//staging api's
export const getStaging = async (data) => {
  try {
    return await AoneService.post(`revenue/api/v1/invoice/staging/delivered`,data);
  } catch (error) {
    return error;
  }
};
//get pending calculation
export const getPendingCalculation = async (data) => {
  try {
    return await AoneService.post(`revenue/api/v1/invoice/status/pending-calculation`,data);
  } catch (error) {
    return error;
  }
};
//push invoice
export const pushStageInvoices = async (data) => {
   try {
    return await AoneService.post(`revenue/api/v1/invoice/push/stage/trackings`,data);
  } catch (error) {
    return error;
  }
};
//Revenue recalculation
export const revenueRecalculation = async (data) => {
  try {
    return await AoneService.post(`revenue/api/v1/revenue/recalculate/delivered/discrepancy/trackings`,data);
  } catch (error) {
    return error;
  }
};
export const stageRevenueRecalculation = async (data) => {
  try {
    return await AoneService.post(`revenue/api/v1/revenue/recalculate/delivered/stage/trackings`,data);
  } catch (error) {
    return error;
  }
};
//Recalculate all
export const stageRevenueRecalculationAll = async (data) => {
  try {
    return await AoneService.post(`revenue/api/v1/revenue/recalculate/delivered/stage/filter`,data);
  } catch (error) {
    return error;
  }
};
//recalculate all from revenue
//Recalculate all
export const RevenueRecalculationAll = async (data) => {
  try {
    return await AoneService.post(`revenue/api/v1/revenue/recalculate/delivered/discrepancy/filter`,data);
  } catch (error) {
    return error;
  }
};
//Refund
export const getRefunds = async (params) => {
  try {
    return await AoneService.get(`collections/api/v1/refund/filter?${params}`);
  } catch (error) {
    return error;
  }
};
//get refund by tracking id
export const getRefundbyId = async (params) => {
  try {
    return await AoneService.get(`collections/api/v1/refund?id=${params}`);
  } catch (error) {
    return error;
  }
};
//get transactions
export const getTransactionsbyId = async (params) => {
  try {
    return await AoneService.get(`pg/api/v1/transactions/${params}`);
  } catch (error) {
    return error;
  }
};
//export refund
export const exportRefund = async (params) => {
  try {
    return await AoneService.get(`collections/api/v1/refund/export${params}`, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
//post refund
export const postRefund = async (data) => {
  try {
    return await AoneService.post(`collections/api/v1/refund`, data);
  } catch (error) {
    return error;
  }
};
//delete refund
export const deleteRefund = async (id) => {
  try {
    return await AoneService.delete(`collections/api/v1/refund?id=${id}`);
  } catch (error) {
    return error;
  }
};
//upload refund
export const uploadRefund = async (params,data) => {
  try {
    return await AoneService.post(`collections/api/v1/refund/${params}/upload-attachment`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    return error;
  }
};
//download refund proof
export const downloadRefundProof = async (params) => {
    try {
      return await AoneService.get(`collections/api/v1/refund/${params}/download`,
      {
       responseType: "blob"
      }
    );
    } catch (error) {
      return error;
    }
  };
//refund status
  export const getStatus = async () => {
    try {
      return await AoneService.get(`collections/api/v1/lookups/RefundStatusEnum`);
    } catch (error) {
      return error;
    }
  };
  //get invoice status
    export const getInvoiceStatus = async () => {
    try {
      return await AoneService.get(`revenue/api/v1/lookups/InvoicedStatus`);
    } catch (error) {
      return error;
    }
  };